export const LuxPlusPartnerPromoClassifier = {
  TURO: 'TURO:lux_plus_au2',
  HELLOFRESH: 'HELLOFRESH:lux_plus_au2',
  WINE_SELECTORS: 'WINE_SELECTORS:lux_plus_au2',
} as const

export type LuxPlusPartnerPromoClassifierType = typeof LuxPlusPartnerPromoClassifier[keyof typeof LuxPlusPartnerPromoClassifier]

export const PARTNER_PROMO_CLASSIFIER_VALUES = new Set<string>(
  Object.values(LuxPlusPartnerPromoClassifier),
)
